import ProductTaxEditor from "./ProductTaxEditor";

export default ProductTaxEditor;
